/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Bank Portal APIs
 * OpenAPI spec version: 0.1
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { customInstance } from '../../../../mutator/instance';
import type {
  BanksListDistributionsForBankParams,
  BanksListOrdersForBankParams,
  BondsmithPageCustomerProductOrderResponse,
  CustomerProductDistributionResponse,
} from '../../models';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary List distributions for a bank
 */
export const banksListDistributionsForBank = (
  params?: BanksListDistributionsForBankParams,
  signal?: AbortSignal
) => {
  return customInstance<CustomerProductDistributionResponse[]>({
    url: `/banks/own/instruction/distribution/bank`,
    method: 'GET',
    params,
    signal,
  });
};

export const getBanksListDistributionsForBankQueryKey = (
  params?: BanksListDistributionsForBankParams
) => {
  return [
    `/banks/own/instruction/distribution/bank`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBanksListDistributionsForBankQueryOptions = <
  TData = Awaited<ReturnType<typeof banksListDistributionsForBank>>,
  TError = unknown
>(
  params?: BanksListDistributionsForBankParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof banksListDistributionsForBank>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBanksListDistributionsForBankQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof banksListDistributionsForBank>>
  > = ({ signal }) => banksListDistributionsForBank(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof banksListDistributionsForBank>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BanksListDistributionsForBankQueryResult = NonNullable<
  Awaited<ReturnType<typeof banksListDistributionsForBank>>
>;
export type BanksListDistributionsForBankQueryError = unknown;

/**
 * @summary List distributions for a bank
 */
export const useBanksListDistributionsForBank = <
  TData = Awaited<ReturnType<typeof banksListDistributionsForBank>>,
  TError = unknown
>(
  params?: BanksListDistributionsForBankParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof banksListDistributionsForBank>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBanksListDistributionsForBankQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary List orders for a bank
 */
export const banksListOrdersForBank = (
  params?: BanksListOrdersForBankParams,
  signal?: AbortSignal
) => {
  return customInstance<BondsmithPageCustomerProductOrderResponse>({
    url: `/banks/own/instruction/order/bank`,
    method: 'GET',
    params,
    signal,
  });
};

export const getBanksListOrdersForBankQueryKey = (
  params?: BanksListOrdersForBankParams
) => {
  return [
    `/banks/own/instruction/order/bank`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBanksListOrdersForBankQueryOptions = <
  TData = Awaited<ReturnType<typeof banksListOrdersForBank>>,
  TError = unknown
>(
  params?: BanksListOrdersForBankParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof banksListOrdersForBank>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBanksListOrdersForBankQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof banksListOrdersForBank>>
  > = ({ signal }) => banksListOrdersForBank(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof banksListOrdersForBank>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BanksListOrdersForBankQueryResult = NonNullable<
  Awaited<ReturnType<typeof banksListOrdersForBank>>
>;
export type BanksListOrdersForBankQueryError = unknown;

/**
 * @summary List orders for a bank
 */
export const useBanksListOrdersForBank = <
  TData = Awaited<ReturnType<typeof banksListOrdersForBank>>,
  TError = unknown
>(
  params?: BanksListOrdersForBankParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof banksListOrdersForBank>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getBanksListOrdersForBankQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
